"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountOverview = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackCustomerAccountOverview(click_text, click_url, event_label) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickButton,
        feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
        click_element: event_label,
        click_text,
        click_url,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.CustomerAccount,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: event_label,
        eventData,
    });
}
exports.trackCustomerAccountOverview = trackCustomerAccountOverview;
//# sourceMappingURL=trackCustomerAccountOverview.js.map